import * as React from 'react';
import { cn } from '../../lib/utils';

/* ============================================================================
   CaixaBusca - campo de pesquisa que SO pesquisa quando a pessoa manda.

   PESQUISA POR ENTER OU LUPA, NAO POR TECLA (21/10/2026, a pedido).
   Antes o PainelLista (e as telas com busca propria) disparavam a consulta 350 ms
   depois de parar de digitar. Quem digita devagar, ou corrige uma letra, gerava
   uma consulta por pausa - e em listas de 32 mil dispositivos cada uma pesa no
   banco. O pedido foi "do jeito que esta esta consumindo".

   Agora o texto digitado fica so aqui dentro; a tela recebe o termo por
   `aoBuscar` quando a pessoa aperta Enter ou clica na lupa. O "x" limpa e
   recarrega sem filtro na hora - limpar e uma intencao clara, nao precisa de
   confirmacao.

   Isso tambem fecha a corrida que o debounce so tornava rara (a resposta de "jo"
   chegando depois da de "joao"): sem consulta por tecla, nao ha resposta velha
   competindo com a nova.

   `valor` e o termo que a TELA esta usando. Se ela o limpa por fora ("Limpar
   filtros"), a caixa acompanha.
   ============================================================================ */

export function IconeLupa({ tamanho = 15 }: { tamanho?: number }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
      <path d="M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default function CaixaBusca({
  valor,
  aoBuscar,
  placeholder = 'Pesquisar',
  className,
  autoFocus,
}: {
  valor: string;
  aoBuscar: (termo: string) => void;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
}) {
  const [texto, setTexto] = React.useState(valor);

  React.useEffect(() => setTexto(valor), [valor]);

  const enviar = (termo: string) => aoBuscar(termo);

  return (
    <div
      className={cn(
        'flex h-9 items-center rounded-lg border border-line bg-surface focus-within:border-primary',
        className
      )}
    >
      <input
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== 'Enter') return;
          // Dentro de formulario/modal, Enter aqui e "pesquisar", nao "salvar".
          e.preventDefault();
          e.stopPropagation();
          enviar(texto);
        }}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="h-full min-w-0 flex-1 bg-transparent px-3 text-[12.5px] text-ink outline-none placeholder:text-faint"
      />
      {!!texto && (
        <button
          type="button"
          onClick={() => {
            setTexto('');
            enviar('');
          }}
          aria-label="Limpar busca"
          title="Limpar"
          className="grid h-full w-7 flex-none place-items-center text-[14px] text-faint hover:text-ink"
        >
          ×
        </button>
      )}
      <button
        type="button"
        onClick={() => enviar(texto)}
        aria-label="Pesquisar"
        title="Pesquisar"
        className="grid h-full w-9 flex-none place-items-center rounded-r-lg border-l border-line text-muted-foreground hover:bg-surface-2 hover:text-primary"
      >
        <IconeLupa />
      </button>
    </div>
  );
}
